import AppService from "./app-service"

export default class UserGroupService extends AppService {

  constructor() {
    super({ path: "user-groups" })
  }
}